import React, {FC, Ref} from "react";
import "video-react/dist/video-react.css";
import {
    Player,
    ControlBar,
    ReplayControl,
    ForwardControl,
    CurrentTimeDisplay,
    TimeDivider,
    PlaybackRateMenuButton,
    VolumeMenuButton,
    BigPlayButton
    // @ts-ignore
} from 'video-react';
import './videoViewer.scss';

interface VideoViewerProps{
    playerRef: Ref<any>;
    fileUrl: string;
}

const VideoViewer:FC<VideoViewerProps> = ({playerRef,fileUrl}) => {
    return(
        <div className='video-wrapper'>
            <Player fluid={true} playsInline={true} ref={playerRef}>
                <source src={fileUrl} />
                <ControlBar>
                    <BigPlayButton position={"center"}/>
                    <ReplayControl seconds={10} order={1.1} />
                    <ForwardControl seconds={10} order={1.2} />
                    <CurrentTimeDisplay order={4.1} />
                    <TimeDivider order={4.2} />
                    <PlaybackRateMenuButton rates={[0.25,0.5,0.75,1,1.25,1.5,1.75,2]} order={7.1}/>
                    <VolumeMenuButton vertical />
                </ControlBar>
            </Player>
        </div>
    )
}

export default VideoViewer;
